import type { z } from "zod";

import * as transport from "../../../../transport";
import { ProtocolTransaction_fromPosConnectorResponse } from "../../shared/protocol-transaction-from-pos-connector-response";
import type { PurchaseResponseSchema } from "../schemas";

const resolve = transport.Resolve<"Terminal_purchase">();

export function getApprovedResponse(options: {
	event: z.infer<typeof PurchaseResponseSchema.shape.data>;
	reference: string;
}): {
	response: ReturnType<typeof resolve.$Ok>;
	getPageProps: () => {
		currency: string | undefined;
		totalCents: number;
		surchargeCents: number;
		tipCents: number;
	};
} {
	const { event, reference } = options;

	const response: ReturnType<typeof getApprovedResponse>["response"] =
		resolve.$Ok({
			...ProtocolTransaction_fromPosConnectorResponse(event),
			$type: "Approved",
			externalReference: reference,
			type: "PURCHASE",
		});

	const getPageProps: ReturnType<
		typeof getApprovedResponse
	>["getPageProps"] = () =>
		({
			currency: event.currency,
			totalCents: event.amount,
			surchargeCents: event.surchargeAmount ?? 0,
			tipCents: event.tipAmount ?? 0,
		}) as const;

	return { response, getPageProps };
}
